import * as React from "react"
import { Grid, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrowOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RegionResponseAccordianComponent from './RegionResponseAccordianComponent';
import CheckIcon from '@material-ui/icons/Check';
import * as moment from 'moment';
export default class RegionwiseResponseComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            dashboardData: []
        }
    }

    GetPercentage(dashboardData: any) {
        let totalPercentage = 0;
        let count = 0;
        dashboardData.forEach((element: any) => {
            count = count + 1;
            totalPercentage = totalPercentage + element.totalCompletionPercentage;
        });
        if (count !== 0) {
            return Math.round(totalPercentage / count)
        }
        return count;
    }

    showSelectedRegionCall(selectedRegionName: any) {
        const dashboardData: any = this.props.dashboardData.regionWiseModuleCompletionDto;
        if (dashboardData) {
            dashboardData.forEach((region: any) => {
                if (region.name === selectedRegionName) {
                    this.setState({
                        ["Region_" + region.name]: !this.state["Region_" + region.name]
                    })
                }
            });
        }
    }

    componentDidMount() {
        const dashboardData: any = this.props.dashboardData.regionWiseModuleCompletionDto;
        if (dashboardData) {
            this.setState({ dashboardData })
            dashboardData.forEach((region: any) => {
                this.setState({
                    ["Region_" + region.name]: false
                })
            });
        }
    }

    render() {
        const dashboardData: any = this.state.dashboardData;
        const selectedSurvey = this.props.selectedSurvey ? this.props.selectedSurvey : '';
        const surveyPercentage = dashboardData ? this.GetPercentage(dashboardData) : 0

        return (

            <Grid container={true} spacing={24}>
                <Grid item={true} xs={12}>

                    <div className="media-list-wrapper">
                        <div className="media-list">
                            <ExpansionPanel className="ExpansionPanel ExpansionPanelMain">
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className="ExpansionPanelSummary">

                                    <div className="media-content">
                                        <div className={surveyPercentage === 100 ? "media-left media-box media-box-success media-box-large" : "media-left media-box media-box-primary media-box-large"}>
                                            {surveyPercentage === 100 ? <CheckIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
                                        </div>
                                        <div className="media-body">
                                            <Grid container={true} spacing={8}>
                                                <Grid item={true} xs={6}>
                                                    <Typography variant="caption" className="captionText">
                                                        {selectedSurvey && selectedSurvey.statusText === "Active" ? "ONGOING" : "CLOSED"}
                                                    </Typography>
                                                    <h5 className="mt-0"><span className="strongText">{selectedSurvey && selectedSurvey.title}</span></h5>
                                                    <div className="responseCreated">
                                                        <ul>
                                                            <li>Created: {selectedSurvey && moment(selectedSurvey.createdDate, "YYYY-MM-DD").format("DD-MM-YYYY")}</li>
                                                            <li> {selectedSurvey && selectedSurvey.CountrySelectionType === 0 ? "Global" : "Custom"} </li>
                                                        </ul>
                                                    </div>
                                                </Grid>
                                                <Grid item={true} xs={6} className="text-right">
                                                    <div className="red-text linkRed">
                                                        Deadline: {selectedSurvey && moment(selectedSurvey.deadlineDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <div className="progress">
                                                <div className={surveyPercentage === 100 ? "progress-bar progress-bar-success" : "progress-bar progress-bar-primary"} style={{ width: (surveyPercentage) + '%' }} role="progressbar">
                                                    &nbsp;
                                         </div>
                                            </div>
                                        </div>

                                    </div>
                                </ExpansionPanelSummary>

                                <ExpansionPanelDetails className="ExpansionPanelDetails">
                                    <div className="media-insidecontent-acc-group">
                                        {dashboardData && dashboardData.map((region: any, key: any) => {
                                            return <ExpansionPanel className="ExpansionPanel" key={key}>
                                                <ExpansionPanelSummary onClick={this.showSelectedRegionCall.bind(this, region.name)} expandIcon={<ExpandMoreIcon />} className="ExpansionPanelSummary">
                                                    <div className="media-content">
                                                        <div className="media-body">
                                                            <h5 className="mt-0"><span className="strongText">{region.name}</span></h5>
                                                        </div>
                                                        <div className="progress">
                                                            <div className={region && region.totalCompletionPercentage === 100 ? "progress-bar progress-bar-success" : "progress-bar progress-bar-primary"} style={{ width: (region ? region.totalCompletionPercentage : 0) + '%' }} role="progressbar">
                                                                &nbsp;
                                                        </div>
                                                        </div>
                                                    </div>
                                                </ExpansionPanelSummary>
                                                {region && this.state["Region_" + region.name] !== null && this.state["Region_" + region.name] &&
                                                    <RegionResponseAccordianComponent
                                                        surveyYear={selectedSurvey.deadlineDate}
                                                        region={region}
                                                        selectedSurvey={selectedSurvey}
                                                        countryModuleDetails={this.props.countryModuleDetails}
                                                        isAdmin={this.props.isAdmin}
                                                    />
                                                }
                                            </ExpansionPanel>

                                        })}
                                    </div>


                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>

                    </div>
                </Grid>
            </Grid>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AdminDashboardResponse/RegionwiseResponseComponent.tsx